import { render, staticRenderFns } from "./TypographyPresetLabelAndIdInput.vue?vue&type=template&id=780859a6&"
import script from "./TypographyPresetLabelAndIdInput.vue?vue&type=script&lang=ts&"
export * from "./TypographyPresetLabelAndIdInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports